import { RouteType } from "types/RouteType";
import type DeveloperMetricsStore from "./DeveloperMetricsStore";

/**
 * Reports → Developer metrics: the nightly git metrics as live data.
 *
 * Any live staff member may read it (the API refuses portal users, API keys and
 * deactivated sessions), so the route is not admin-gated. The one admin-only
 * thing on the page — fixing an unmatched developer — links to Administration →
 * Git Identities and is offered only to admins.
 */
const developerMetricsRoute: RouteType = {
  name: "Developer Metrics",
  title: "Developer Metrics",
  path: "/reports/developer-metrics",
  layout: "/app",
  viewportCard: {
    header: {
      enableBackButton: true,
      title: "Developer Metrics",
      enableRefreshButton: true,
      color: "primary",
      component: () => import("./DeveloperMetrics.Header"),
    },
    body: {
      component: () => import("./DeveloperMetrics.Body"),
      grayBackground: true,
    },
  },
  group: "Reports",
  searchAliases: [
    "git metrics",
    "developer output",
    "commits",
    "code survival",
    "ai assisted",
  ],
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  onEnter: ({ rootStore }) => {
    void (
      rootStore.developerMetricsViewStore as DeveloperMetricsStore | undefined
    )?.load();
  },
};

export default developerMetricsRoute;
